import { apiFetch } from "./client";

const fetchProducts = async ({ includeArchived = false, state } = {}) => {
  const params = new URLSearchParams();
  if (includeArchived) params.set("includeArchived", "1");
  if (state) params.set("state", state);

  const suffix = params.toString() ? `?${params.toString()}` : "";
  return apiFetch(`/api/products${suffix}`);
};

const createProduct = async (payload) => {
  try {
    return await apiFetch("/api/products", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  } catch (err) {
    const error = new Error(err?.message || "Unable to create product via API.");
    error.cause = err;
    throw error;
  }
};

const updateProduct = async (id, payload) => {
  try {
    return await apiFetch(`/api/products/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  } catch (err) {
    const error = new Error(err?.message || "Unable to update product via API.");
    error.cause = err;
    throw error;
  }
};

const importProducts = async ({ products, dryRun = false } = {}) => {
  try {
    return await apiFetch("/api/products/bulk/import", {
      method: "POST",
      body: JSON.stringify({ products, dryRun }),
    });
  } catch (err) {
    const error = new Error(err?.message || "Unable to import products via API.");
    error.cause = err;
    error.data = err?.data;
    throw error;
  }
};

const archiveProduct = async (id) =>
  apiFetch(`/api/products/${id}/archive`, {
    method: "POST",
  });

const bulkArchiveProducts = async (ids) =>
  apiFetch("/api/products/bulk/archive", {
    method: "POST",
    body: JSON.stringify({ ids }),
  });

const restoreProduct = async (id) =>
  apiFetch(`/api/products/${id}/restore`, {
    method: "POST",
  });

const bulkRestoreProducts = async (ids) =>
  apiFetch("/api/products/bulk/restore", {
    method: "POST",
    body: JSON.stringify({ ids }),
  });

export {
  fetchProducts,
  createProduct,
  updateProduct,
  importProducts,
  archiveProduct,
  bulkArchiveProducts,
  restoreProduct,
  bulkRestoreProducts,
};
